import { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { templatesApi, type Template } from "../api/templates";

export function TemplatesPage() {
  const [templates, setTemplates] = useState<Template[]>([]);
  const navigate = useNavigate();

  async function refresh() {
    const res = await templatesApi.list();
    setTemplates(res.templates);
  }

  useEffect(() => {
    refresh();
  }, []);

  async function remove(id: string) {
    if (!confirm(`Delete template "${id}"?`)) return;
    await templatesApi.remove(id);
    await refresh();
  }

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Templates</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/templates/new")}
        >
          New template
        </Button>
      </Stack>
      <Card>
        <CardContent>
          {templates.length === 0 ? (
            <Typography color="text.secondary">
              No templates yet. Create one to call <code>POST /send</code> with a templateId.
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Subject</TableCell>
                  <TableCell>Updated</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {templates.map((t) => (
                  <TableRow
                    key={t.templateId}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => navigate(`/templates/${t.templateId}`)}
                  >
                    <TableCell>
                      <code>{t.templateId}</code>
                    </TableCell>
                    <TableCell>{t.name}</TableCell>
                    <TableCell>{t.subject}</TableCell>
                    <TableCell>{new Date(t.updatedAt).toLocaleString()}</TableCell>
                    <TableCell align="right">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          remove(t.templateId);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
